// extracted by mini-css-extract-plugin
export default {"nav-container":"Navigation_nav-container__QHA35","nav-heading":"Navigation_nav-heading__0nMVK","home":"Navigation_home__FR2l5"};